import React, { useContext, useState } from "react";
import { Button, Steps, theme } from "antd";
import { useNavigate } from "react-router";
import { context } from "../context/context";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { toast } from "react-toastify";
import AdsFormStepOne from "./../components/Ads/AdsFormStepOne";
import AdsFormStepTwo from "./../components/Ads/AdsFormStepTwo";
import { NavLink } from "react-router-dom";

const steps = [
    {
        title: "قدم اول",
        content: <AdsFormStepOne />,
    },
    {
        title: "قدم دوم",
        content: <AdsFormStepTwo />,
    },
];
const EditAdvertisement = () => {
    const { token } = theme.useToken();
    // state
    const [current, setCurrent] = useState(0);
    // context
    const {
        selectedAdId,
        setAdCover,
        adCoverId,
        adDescription,
        adEndDate,
        adLimit,
        adLink,
        adNumOfSlide,
        adPosition,
        adPriority,
        adStartDate,
        adTags,
        adTitle,
        adCover,
    } = useContext(context);

    // functions
    const next = () => {
        setCurrent(current + 1);
    };
    const navigate = useNavigate();
    const handleSubmit = () => {
        http.post(
            `${config.parkopoloApi}/api/Advertise/editAds/${selectedAdId}`,
            {
                priority: adPriority,
                link: adLink,
                tags: adTags,
                position: adPosition,
                limit: adLimit,
                date: {
                    start: adStartDate,
                    end: adEndDate,
                },
                title: adTitle,
                description: adDescription,
                coverPic: adCoverId,
                numOfSlide: adNumOfSlide,
            }
        )
            .then((res) => {
                toast.success("تبلیغ با موفقیت ویرایش شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(res.data.success);
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
            });
        setAdCover([]);
        navigate("/ads", { replace: true });
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        lineHeight: "260px",
        textAlign: "center",
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
    };
    return (
        <div style={{ direction: "ltr" }}>
            <Steps current={current} items={items} />
            <div style={contentStyle}>{steps[current].content}</div>
            <div
                style={{
                    marginTop: 24,
                    textAlign: "left",
                    display: "flex",
                    gap: 10,
                }}
            >
                {current < steps.length - 1 && (
                    <Button
                        type="primary"
                        onClick={() => next()}
                        disabled={
                            !adTitle ||
                            adTitle === "" ||
                            !adCoverId ||
                            adCoverId === "" ||
                            adCover.length === 0 ||
                            !adEndDate ||
                            !adStartDate ||
                            !adLink ||
                            adLink === ""
                        }
                    >
                        مرحله بعد
                    </Button>
                )}
                {current === steps.length - 1 && (
                    <Button
                        disabled={
                            !adLimit ||
                            !adNumOfSlide ||
                            !adPosition ||
                            !adPriority ||
                            adLimit === "" ||
                            adNumOfSlide === "" ||
                            adPosition === "" ||
                            adPriority === ""
                        }
                        type="primary"
                        onClick={() => handleSubmit()}
                    >
                        ثبت
                    </Button>
                )}
                {
                    <NavLink to="/ads">
                        <Button type="primary" danger>
                            لغو
                        </Button>
                    </NavLink>
                }
            </div>
        </div>
    );
};

export default EditAdvertisement;
